import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import LoyaltyOfferCard from "../LoyaltyOfferCard/LoyaltyOfferCard";
import LoyaltyBreadcrumbs from "../LoyaltyBreadcrumbs/LoyaltyBreadcrumbs";
import "./OfferDetail.css";

export default function OfferDetail({ offers }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const current = offers.find((o) => o.id === id);

  if (!current) {
    return <p>Offer not found.</p>;
  }

  // 1. Related offers by shared category
  const relatedOffers = offers.filter((o) => {
    if (o.id === id) return false;
    return o.category?.some((cat) => current.category?.includes(cat));
  });

  // 2. Fallback to random offers
  const fallbackRandom = offers
    .filter((o) => o.id !== id)
    .sort(() => 0.5 - Math.random());

  // 3. Final list: related if available, otherwise random
  const displayOffers = (
    relatedOffers.length > 0 ? relatedOffers : fallbackRandom
  )
    .sort(() => 0.5 - Math.random())
    .slice(0, 4);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: true,
        },
      },
    ],
  };

  return (
    <div className="offer-detail-page">
      <LoyaltyBreadcrumbs />

      <button
        className="back-button"
        onClick={() => navigate("/loyalty-program")}
      >
        ← Back to all offers
      </button>

      <div className="featured-offer-wrapper">
        <h2 className="featured-title">Featured Offer</h2>
        <div className="featured-offer-card">
          <LoyaltyOfferCard offer={current} />
        </div>
      </div>

      <h2 className="carousel-title">More offers you might like</h2>
      <Slider
        {...settings}
        className="offers-carousel"
      >
        {displayOffers.map((offer) => (
          <div
            key={offer.id}
            className="slide"
          >
            <button
              className="slide-button"
              onClick={() =>
                window.open(`/loyalty-program/${offer.id}`, "_blank")
              }
            >
              <LoyaltyOfferCard offer={offer} />
            </button>
          </div>
        ))}
      </Slider>
    </div>
  );
}
